import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/person-assignment/PersonAssignmentAction";
import { getAuthorities, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { TeachersFilter } from "./teachers-filter/TeachersFilter";
import { TeachersTable } from "./teachers-table/TeachersTable";
import { useTeachersUIContext } from "./TeachersUIContext";

export function TeachersCard() {
  // Teachers Card UI Context
  const teachersUIContext = useTeachersUIContext();
  const teachersUIProps = useMemo(() => {
    return {
      history: teachersUIContext.history,
      receipentType: teachersUIContext.receipentType,
      noticeGroupId: teachersUIContext.noticeGroupId,
      ids: teachersUIContext.ids
    };
  }, [teachersUIContext]);

  // Getting curret state of Teachers from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.personAssignment }),
    shallowEqual
  );  
  const { authorities } = currentState;

  // Authority Parameters
    const { isEditionAuthorized } = getAuthorities(authorities);

  // Teachers Redux state
  const dispatch = useDispatch();

  // Belli Bir Duyuru Grubuna Ait Kişi Listesini Kaydeder
  const savePeople = (ids) => {
    dispatch(actions.savePeople(teachersUIProps.receipentType, teachersUIProps.noticeGroupId, ids)).then(result => onResult(result));
  }
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => teachersUIProps.history.push(`/kisi-ve-duyuru-gruplari/${teachersUIProps.receipentType}`), 2500);
  };

  const title = <>Öğretmen Listesi{teachersUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{teachersUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title}>
        {
          isEditionAuthorized &&
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => savePeople(teachersUIProps.ids)}
            >
              Kaydet
            </button>
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <TeachersFilter />
        <TeachersTable />
      </CardBody>
    </Card>
  );
}